import { SITE_DOMAIN } from './constants';

export const CONTACT_EMAIL = `info@${SITE_DOMAIN}`;
export const CONTACT_PHONE = {
	number: '+19199739537',
	display: '(919) 973-9537'
};

export type FormParams = {
	name: string;
	email: string;
	phone: string;
	service: string;
	address: string;
	city: string;
	zip: number;
	message: string;
};

export type FormFields =
	| 'name'
	| 'email'
	| 'phone'
	| 'service'
	| 'address'
	| 'city'
	| 'zip'
	| 'message';

export interface Error {
	missing?: boolean;
	invalid?: boolean;
}

export type FormErrors = {
	[key in FormFields]?: Error;
};
